export default (context, inject) => {

  console.log('Inside favicon plugins, context, urlFavicon', context);


  const setFavicon = (url) => {
    console.log('Inside favicon plugins, urlFavicon', url);
    const link = document.querySelector("link[rel~='icon']") || document.createElement('link');
    link.rel = 'icon';
    link.href = url;
    document.head.appendChild(link);
  };

  // Same for title
  const setTitle = (title) => {
    if (typeof title === 'string') {
      document.title = title;
    }
  };

  // Inject the function into the Nuxt context
  inject('setTitle', setTitle);



  // Inject the function into the Nuxt context
  inject('setFavicon', setFavicon);
};
